import React, { forwardRef } from "react";
import WSBarcodeLabel from "../../Components/BarCode/WSBarCodeLabel";

interface Props {
  barcode: string;
  name: string;
}

const BarcodePrintLabel = forwardRef<HTMLDivElement, Props>(
  ({ barcode, name }, ref) => {
    return (
      <div ref={ref} style={{ padding: 10 }}>
        <WSBarcodeLabel barcode={barcode} name={name} />
      </div>
    );
  }
);

export default BarcodePrintLabel;